import React from "react";
import {SkeletonTheme} from "react-loading-skeleton";

export const SkeletonWrapper = ({children}) => {

    return (
        <SkeletonTheme baseColor={'#e6e6e6'}
                       highlightColor={'#f3f3f3'}
                       duration={1.2}>
            {children}
        </SkeletonTheme>
    );
}